<template>
  <vue-circle
    ref="circleProgress"
    :progress="percent"
    :size="50"
    :reverse="false"
    :fill="fill"
    :animation-start-value="0.0"
    :start-angle="-Math.PI / 2"
    :thickness="5"
    :show-percent="false"
    line-cap="square"
    empty-fill="#E0DEDF"
    insert-mode="append"
  >
    <slot name="circle-content" />
  </vue-circle>
</template>

<script>
  import VueCircle from 'vue2-circle-progress';

  export default {
    name: 'ProgressCircleComponent',
    components: {
      VueCircle,
    },
    props: {
      percent: {
        type: Number,
        default: 0,
      },
      fill: {
        type: Object,
        default: () => ({
          color: '#0094de',
        }),
      },
    },
    watch: {
      percent(newValue) {
        this.$refs.circleProgress.updateProgress(newValue);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';
  @import 'compass/css3/transform';

  /deep/.circle {
    height: 50px;
  }
</style>
